/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetContractStatusHistoryRequest = {
  properties: {
    contractId: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
